import { combineEpics } from "redux-most";
import * as steps from "common/steps";
import * as uploadActions from "./uploadActions";
import * as submissionActions from "submission/submissionActions";
import { isStepCompleted, getWorkFiles } from "common/selectors";
import {
  createSyncLocalStorageEpic,
  createLoadLocalStorageEpic,
  createCompleteStepEpic,
  createAcknowledgeSubmissionEpic,
} from "common/stepEpicCommon";

const syncLocalStorageEpic = createSyncLocalStorageEpic(
  [
    submissionActions.ADD_ANOTHER_WORK,
    submissionActions.CANCEL_SUBMISSION,
    submissionActions.SUBMIT,
    submissionActions.SET_SUBMISSION_FILES,
    submissionActions.UPDATE_SUBMISSION_FILES,
    uploadActions.COMPLETE_STEP,
    uploadActions.SET_WORK_FILES,
    uploadActions.UPDATE_WORK_FILES,
  ],
  {
    completed: isStepCompleted(steps.FILE_UPLOAD),
    workFiles: getWorkFiles,
  },
  uploadActions.localStorageSynced,
  steps.FILE_UPLOAD
);

export default combineEpics([
  createAcknowledgeSubmissionEpic(steps.FILE_UPLOAD),
  createCompleteStepEpic(uploadActions.COMPLETE_STEP, steps.FILE_UPLOAD),
  createLoadLocalStorageEpic(
    steps.FILE_UPLOAD,
    uploadActions.localStorageLoaded
  ),
  syncLocalStorageEpic,
]);
